'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');
const Months = require('../../helpers/months.js');

const _ = require('lodash');

const DatePicker = React.createClass({
  mixins: [ControlMixin],

  getInitialState() {
    return {
      selectedDate: null,
      showCalendar: false,
      month: null,
      year: null,
    };
  },

  componentDidMount(){
    let textInput = this.state.textInput;
    let day;
    let month;
    let year;
    if (textInput) {
      let dateValues = textInput.split('/');
      month = parseInt(dateValues[0]-1);
      day = parseInt(dateValues[1]);
      year = parseInt(dateValues[2]);
      this.setState({month:month, year: year});
    } else {
      let today = new Date();
      month = today.getMonth();
      day = today.getDate();
      year = today.getFullYear() +1;
      this.setState({month:month, year: year});      
    }
  },

  changeDateFromCalender(dateValue) {
    let day = dateValue.day;
    let month = dateValue.month;
    let year = dateValue.year;
    this.setState({selectedDate: dateValue, showCalendar: false}, this.handleChangeText(`${month+1}/${day}/${year}`));
  },

  toggleCalendar() {
    this.setState({showCalendar: !this.state.showCalendar});
  },

  changeMonth(currentMonth, newMonth) {
    if (currentMonth === 11 && newMonth === 0) {
      this.setState({month:newMonth, year: this.state.year +1});
    } else if (currentMonth === 0 && newMonth === 11) {
      this.setState({month:newMonth, year: this.state.year -1});
    } else {
      this.setState({month:newMonth, year:this.state.year});
    }
  },

  renderCalendar() {
    let month = this.state.month;
    let year = this.state.year
    let weekday = new Date(year, month, 1).getDay();
    let dayNum;

    if(month === 0 || month === 2 || month === 4 || month === 6 || month === 7 || month === 9 || month === 11) {
      dayNum = 31;
    } else if(month === 3 || month === 5 || month === 8 || month === 10) {
      dayNum = 30;
    } else {
      (year - 2016) % 4 === 0 ? dayNum = 29 : dayNum = 28;
    }

    let calendarValues = [];

    for (var i = weekday; i > 0; i--) {
      calendarValues.push({
        day:null, 
        value:null,
        className: false,
      });
    }
    for (var i = 1; i <= dayNum; i++) {
      calendarValues.push({
        day:i, 
        value:{
          month:month, 
          day: i, 
          year: year
        }, 
        monthStart: weekday
      });
    }
    let selectedYear = _.get(this.state.selectedDate, 'year');
    let selectedMonth = _.get(this.state.selectedDate, 'month');
    let selectedDay = _.get(this.state.selectedDate, 'day');

    let items = _.map(calendarValues, (item, i)=>{
      let highlightDay;
      let itemYear = _.get(item.value, 'year');
      let itemMonth = _.get(item.value, 'month');
      let itemDay = _.get(item.value, 'day');
      if (selectedYear === itemYear && selectedMonth === itemMonth && selectedDay === itemDay && selectedDay !== undefined) {
        highlightDay = 'uc-selected-day'
      } else { highlightDay = ''}
      return (
        <li 
          key={i} 
          className={item.day ? "box-date": null}
          id={highlightDay} 
          value={item.value} 
          onClick={item.day ? this.changeDateFromCalender.bind(null, item.value) : null }>
          {item.day ? item.day : ' '}
        </li>
      )
    });

    return(
      <ul className="days">  
        {items}
      </ul>
    )
  },

  setDefaultDate() {
    let month;
    let day;
    let year;

    if(this.state.selectedDate) {
      day = _.get(this.state.selectedDate, 'day');
      month = Months[_.get(this.state.selectedDate, 'month')];
      year = _.get(this.state.selectedDate, 'year');
    } else if (this.state.textInput && !this.state.selectedDate) {
      let dateValues = this.state.textInput.split('/');
      month = Months[dateValues[0] -1];
      day = dateValues[1];
      year = dateValues[2];
    } else {
      let today = new Date();
      month = Months[today.getMonth()];
      day = today.getDate();
      year = today.getFullYear() + 1;
    }

    return `${month} ${day}, ${year}`;
  },

  render() {
    let currentMonth = this.state.month;
    let lastMonth = currentMonth > 0 ? currentMonth - 1 : 11;
    let nextMonth = currentMonth < 11 ? currentMonth + 1 : 0;
    let monthName = Months[currentMonth];

    return (
      <div className='uc-control'>
        <div className="uc-date-input" onClick={this.state.locked ? null : this.toggleCalendar}>
          <h4><i className="fa fa-calendar-o" aria-hidden="true"></i>   {this.setDefaultDate()}</h4>
        </div>

        {!this.state.locked ? (
          <div className="uc-control-date-picker" style={{visibility: this.state.showCalendar ? 'visible' : 'hidden'}}>
            <div className='background-div' onClick={this.toggleCalendar}></div>
            <div className="month">      
              <ul>
                <li className="prev">
                  <i className="fa fa-arrow-left" aria-hidden="true" onClick={this.changeMonth.bind(null, currentMonth, lastMonth)}></i>
                </li>
                <li className="next">
                  <i className="fa fa-arrow-right" aria-hidden="true" onClick={this.changeMonth.bind(null, currentMonth, nextMonth)}></i>
                </li>
                <li style={{textAlign: "center"}}>
                  {monthName} {this.state.year}
                </li>
              </ul>
            </div>
            <ul className="weekdays">
              <li>S</li>
              <li>M</li>
              <li>T</li>
              <li>W</li>
              <li>Th</li>
              <li>F</li>
              <li>S</li>
            </ul>
            {this.renderCalendar()}
          </div> 
          ) : null
        }
      </div>
    );
  }
});

module.exports = DatePicker;



// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/DatePicker.jsx